module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-EPI"
  }, [_vm._v("WHEN YOU OPERATE IN AN OVERBUILT METROPOLIS,"), _c('br'), _vm._v("YOU HAVE TO HACK YOUR WAY WITH A MEAT AX.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPIC"
  }, [_vm._v("—ROBERT MOSES")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPI"
  }, [_vm._v("THE FIRST DUTY IN LIFE IS TO ASSUME A POSE."), _c('br'), _vm._v("WHAT THE SECOND IS, NO ONE HAS YET DISCOVERED.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPIC"
  }, [_vm._v("—OSCAR WILDE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a3a2c7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fussell_Muscle_4P_MD5.vue
// module id = 75
// module chunks = 0